import { Trans, useTranslation } from 'react-i18next'

type InputProps = {
  isTermsAndConditionsAccepted: boolean
  requestConfirmTerms: (params: unknown) => void
  apiHost: string | undefined
}

export const AcceptTerms = ({ isTermsAndConditionsAccepted, requestConfirmTerms, apiHost }: InputProps) => {
  const { t } = useTranslation()

  return (
    <div className="OrderSummary__terms">
      <input
        checked={isTermsAndConditionsAccepted}
        type="checkbox"
        disabled={isTermsAndConditionsAccepted}
        onChange={requestConfirmTerms}
      />
      <p>
        <Trans key="order.i_accept_terms">
          {t('order.i_accept')}{' '}
          <a href={`${apiHost}client/profile/sla?type=html`} target="_blank" rel="noreferrer">
            {t('order.terms_of_service')}
          </a>
        </Trans>
      </p>
    </div>
  )
}
